export default {"src":"/_next/static/media/arrow-right-circle.8a4f595c.svg","height":23,"width":23};